/* Generated from works_backend_development/resources/help-editor; edit that source and rebuild. */

// links.json
var links_default = {
  hosts: [
    "zuopin.cloud",
    "www.zuopin.cloud",
    "m.zuopin.cloud",
    "mp.zuopin.cloud",
    "test.zuopin.cloud",
    "dev.zuopin.cloud",
    "devmp.zuopin.cloud",
    "api.zuopin.cloud",
    "apicdn.zuopin.cloud",
    "ad.zuopin.cloud",
    "ad.yunzuopin.com.cn"
  ],
  features: {
    console: {
      label: "\u63A7\u5236\u53F0",
      path: "/pages/homePage/homePage",
      aliases: []
    },
    cards: {
      label: "\u540D\u7247",
      path: "/pages/homePage/homePage?task=cards",
      aliases: [
        "/subPage/chooseTitle/chooseTitle",
        "/subPage/help/help?task=cards"
      ]
    },
    profile: {
      label: "\u4E2A\u4EBA\u4E2D\u5FC3",
      path: "/pages/homePage/homePage?section=manage",
      aliases: [
        "/subPage2/userEdite/userEdite"
      ]
    },
    preferences: {
      label: "\u504F\u597D\u8BBE\u7F6E",
      path: "/pages/homePage/homePage?task=preferences",
      aliases: [
        "/subPage/setting/setting",
        "/subPage/help/help?task=preferences"
      ]
    },
    tags: {
      label: "\u4F5C\u54C1\u6807\u7B7E",
      path: "/pages/homePage/homePage?section=tags",
      aliases: [
        "/subPage2/userTagList/userTagList"
      ]
    },
    visitors: {
      label: "\u8BBF\u5BA2",
      path: "/pages/homePage/homePage?section=visitors",
      aliases: [
        "/subPage/visitorHistory/visitorHistory"
      ]
    },
    team: {
      label: "\u56E2\u961F",
      path: "/pages/homePage/homePage?task=team",
      aliases: [
        "/subPage2/subUser/list",
        "/subPage/help/help?task=team"
      ]
    },
    generalEntry: {
      label: "\u4E07\u80FD\u5165\u53E3",
      path: "/pages/homePage/homePage?task=generalEntry",
      aliases: [
        "/subPage/publicPage/index",
        "/subPage2/xaCode/general"
      ]
    },
    recent: {
      label: "\u6700\u8FD1\u6D4F\u89C8",
      path: "/pages/cases/index",
      aliases: []
    },
    advisor: {
      label: "\u6280\u672F\u652F\u6301",
      path: "/subPage/newGuide/index?channel=3&task=advisor",
      aliases: [
        "/subPage/searchIndex/index",
        "/subPage/help/help?channel=3&task=advisor"
      ]
    },
    renewalKey: {
      label: "\u7EED\u671F\u5BC6\u94A5",
      path: "/pages/homePage/homePage?task=renewalKey",
      aliases: [
        "/subPage/help/help?task=renewalKey"
      ]
    },
    renewal: {
      label: "\u7EED\u671F",
      path: "/pages/homePage/homePage?renew=1",
      aliases: []
    },
    files: {
      label: "\u6587\u4EF6\u76EE\u5F55",
      path: "/pages/homePage/homePage?task=baiduFiles",
      aliases: [
        "/pages/fileList/fileList",
        "/subPage/fileList/fileList"
      ]
    },
    guide: {
      label: "\u4F7F\u7528\u5F15\u5BFC",
      path: "/subPage/newGuide/introduction",
      aliases: [
        "/subPage/finishGuide/index"
      ]
    },
    onboarding: {
      label: "\u5F00\u59CB\u4F7F\u7528",
      path: "/subPage/newGuide/index",
      aliases: []
    },
    manual: {
      label: "\u4E91\u4F5C\u54C1\u8BF4\u660E\u4E66",
      path: "/pages/homePage/homePage?task=helpManual",
      aliases: [
        "/subPage/newGuide/index?task=helpManual",
        "/subPage/help/help",
        "/subPage/userHelp/userHelp"
      ]
    }
  }
};

// links.js
var features = links_default.features;
function fail() {
  throw new Error("\u8BF7\u9009\u62E9\u73B0\u6709\u6587\u7AE0\u6216\u529F\u80FD\uFF0C\u5916\u90E8\u7F51\u5740\u9700\u4EE5 https:// \u6216 http:// \u5F00\u5934");
}
function parseLink(input) {
  let value = String(input || "").trim().replace(/&amp;/g, "&");
  if (!value || /[\u0000-\u001f\u007f]/.test(value)) return fail();
  value = value.replace(/^(?:https?:)?\/{1,3}(?=(?:pages|subPage2?)\/)/i, "/");
  if (/^(?:pages|subPage2?)\//.test(value)) value = "/" + value;
  const remote = /^(?:https?:)?\/\/([^/]+)(\/[^#]*)?/i.exec(value);
  const host = remote && remote[1].toLowerCase();
  const local = !remote || links_default.hosts.includes(host);
  const pathAndQuery = remote && local ? remote[2] || "/" : value;
  const [path, search = ""] = pathAndQuery.split("#")[0].split("?");
  if (local && /^\/(?:pages|subPage2?)\//.test(path)) {
    const query = {};
    search.split("&").filter(Boolean).forEach((pair) => {
      const at = pair.indexOf("=");
      const decode = (part) => {
        try {
          return decodeURIComponent(part.replace(/\+/g, " "));
        } catch (_) {
          return part;
        }
      };
      query[decode(at < 0 ? pair : pair.slice(0, at))] = decode(at < 0 ? "" : pair.slice(at + 1));
    });
    if (path === "/subPage/userHelp/userHelpDetail" || path === "/subPage/help/help" && query.articleId || ["/pages/homePage/homePage", "/subPage/newGuide/index"].includes(path) && query.task === "helpArticle") {
      const id = query.articleId || query.id || query.scene;
      if (!/^\d+$/.test(id) || !Number.isSafeInteger(Number(id)) || Number(id) < 1) return fail();
      return { type: "article", id: Number(id) };
    }
    delete query.navLeft;
    if (path === "/subPage/searchIndex/index" && query.pay === "1") return { type: "feature", target: "renewalKey" };
    for (const target of Object.keys(features).reverse()) {
      const feature = features[target];
      const [featurePath, featureSearch = ""] = feature.path.split("?");
      const queryString = Object.keys(query).sort().map((key) => key + "=" + query[key]).join("&");
      const matches = path === featurePath && queryString === featureSearch;
      const alias = feature.aliases.some((value2) => value2.includes("?") ? value2 === path + "?" + queryString : value2 === path && (path !== "/subPage/help/help" || !query.task));
      if (matches || alias) return { type: "feature", target };
    }
    return fail();
  }
  const email = /^(?:email|mailto):([^\s@]+@[^\s@]+\.[^\s@]+)$/i.exec(value);
  if (email) return { type: "email", value: email[1] };
  const phone = /^tel:(\+?[0-9() -]{3,30})$/i.exec(value);
  if (phone) return { type: "phone", value: phone[1] };
  if (/^https?:\/\/[^\s/@]+(?:\/|$)/i.test(value)) return { type: "url", value };
  return fail();
}
function linkHref(link) {
  if (link.type === "article" && Number.isInteger(link.id) && link.id > 0) return "/pages/homePage/homePage?task=helpArticle&id=" + link.id;
  if (link.type === "feature" && features[link.target]) return features[link.target].path;
  if (link.type === "email") return "email:" + link.value;
  if (link.type === "phone") return "tel:" + link.value;
  if (link.type === "url") return link.value;
  return fail();
}
function normalizeLink(value) {
  return linkHref(parseLink(value));
}

// reader.js
function renderDocument(container, document, hrefFor = linkHref) {
  if (!document || document.schema_version !== 1 || !Array.isArray(document.blocks)) throw new Error("\u6587\u7AE0\u683C\u5F0F\u65E0\u6548");
  const dom = container.ownerDocument;
  const fragment = dom.createDocumentFragment();
  function inline(parent, runs) {
    let activeLink = null;
    let anchor = null;
    for (const run of runs) {
      let text = dom.createTextNode(run.text);
      for (const [mark, tag] of [["code", "code"], ["strike", "s"], ["italic", "em"], ["bold", "strong"]]) {
        if (!run[mark]) continue;
        const node = dom.createElement(tag);
        node.appendChild(text);
        text = node;
      }
      const href = run.link ? hrefFor(run.link) : null;
      const linkKey = run.link ? linkHref(run.link) : null;
      if (linkKey !== activeLink) {
        anchor = href === null ? null : dom.createElement("a");
        if (anchor) {
          anchor.setAttribute("href", href);
          anchor.dataset.helpLink = JSON.stringify(run.link);
          parent.appendChild(anchor);
        }
        activeLink = linkKey;
      }
      if (anchor) {
        anchor.appendChild(text);
      } else parent.appendChild(text);
    }
  }
  for (const block of document.blocks) {
    if (block.type === "list") {
      const list = dom.createElement(block.ordered ? "ol" : "ul");
      if (block.ordered) list.start = block.start || 1;
      for (const item of block.items) {
        const li = dom.createElement("li");
        inline(li, item.runs);
        list.appendChild(li);
      }
      fragment.appendChild(list);
    } else {
      const tag = { paragraph: "p", heading: "h2", code: "pre" }[block.type];
      if (!tag) throw new Error("\u6587\u7AE0\u683C\u5F0F\u65E0\u6548");
      const node = dom.createElement(tag);
      inline(node, block.runs);
      fragment.appendChild(node);
    }
  }
  container.replaceChildren(fragment);
}
export {
  features,
  linkHref,
  normalizeLink,
  parseLink,
  renderDocument
};
